import moment from 'moment';

const parser = (type, attr) => {
  switch(type) {
    case 'DATE': {
      let dateParsed = moment(attr).utc().format("DD/MM/YYYY");
      if (dateParsed === 'Invalid date') {
        dateParsed = attr;
      }
      return dateParsed;
    }
    case 'TYPE': return attr ? 'Electrónica' : 'Manual';
    case 'UYU':  return 'UYU ' +  attr;
    case 'STATE':
      switch(attr) {
        case 'REQUESTED':            return 'Pago Solicitado';
        case 'REJECTED':             return 'Pago Rechazado';
        case 'IN_PROGRESS':          return 'Pago en Proceso';
        case 'PROCESSED':            return 'Pago Procesado';
        case 'PENDING':              return 'Facturas pendientes';
        case 'ORDER_DELETED':        return 'Eliminada';
        case 'INVOICES_ADDED':       return 'Facturas asociadas';
        case 'PAYMENT_PENDING':      return 'Pago solicitado';
        case 'PAYMENT_PARCIAL':      return 'Pagada parcialmente';
        case 'COMPLETE_IN_PROGRESS': return 'Orden Completa en proceso';
        case 'COMPLETE_PROCESSED':   return 'Orden Completa';
        default:                     return 'Todos los estados';
      }
    default: return '';
  }
}

export default parser;